import { browserHistory } from "react-router";
import { prependRoot } from "./prependRoot.js";
import { getState } from "../store/configureStore";
import { getHistory } from '../util/configureHistory';

const redirector = {
	goTo: function (path) {
		const destination = prependRoot(path, getState().settings.siteRoot);
		if (window.location.pathname !== destination)
			getHistory().push(destination);
	},
	goToHome: function () {
		redirector.goTo("/");
	},
	goToNotFound: function () {
		redirector.goTo("/nietgevonden");
	},
	goToSimulatieDossierClosed: function () {
		redirector.goTo("/afgesloten");
	}
};

export default redirector;
